import * as React from "react";
import { UserRole } from "../../../../../../Wrap/Models/Domains/UserRoles/UserRole";

interface IUserGroupProps {
    gData: Array<UserRole>;
    othergData: Array<UserRole>;
}

const renderUserGroup = (gData: Array<UserRole>, lengthDifference: number) => {
    const result = [];
    gData?.forEach((e) => {
        result.push(
            <div className="row">
                <div className="col-12">
                    {e?.Id} - {e?.Name}
                </div>
            </div>
        );
    });

    if (lengthDifference > 0) {
        for (let i = 0; i < lengthDifference; i++) {
            result.push(<br />);
        }
    }
    return result;
};

export const UserGroup = (props: IUserGroupProps) => {
    const _sortedUserGroup = props?.gData?.sort((a, b) => {
        return a?.Id - b?.Id;
    });

    let sizeDifference = 0;
    if (_sortedUserGroup?.length < props.othergData?.length) {
        sizeDifference = props.othergData?.length - _sortedUserGroup.length;
        _sortedUserGroup.push({
            Id: null,
            Name: null,
        });
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h3>
                        <u>User group</u>
                    </h3>
                </div>
            </div>
            {renderUserGroup(props?.gData, sizeDifference)}
        </>
    );
};
